'use strict';

const $ = jQuery.noConflict();
$(function() {

	const work = {
		init: function() {
			this.classAddition();
		},

		classAddition: function() {
			const work = $('.js-work__projects');
			if (work.length > 0) {
				const projectCount = work.find('.work__project').length;

				if (projectCount < 4) {
					work.addClass('work__left-center');
				}
			}
		},
	};

	work.init();
});
